import { ORDER_APIS } from "@/api_framework/api_config";
import { IPaymentDueCancelOrderBody, IPaymentDueCancelOrderResponse } from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
type IQCUpdateAPIResponse = { status: boolean; message: string };

export const useCancelOrderPaymentDueAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (formData: IPaymentDueCancelOrderBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response: IQCUpdateAPIResponse = await axios
          .put(`${ORDER_APIS?.CANCEL_ORDER_PAYMENT_DUE?.baseURL}`, formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<IPaymentDueCancelOrderResponse>) => {
            if (res.data.status === true) {
              toast.success("Order data cancelled successfully");
              return { status: true, message: "batch" };
            } else {
              toast.error("Order data cancelled failed");
              return { status: false, message: "batch" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "batch" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
